import {
  Event,
  AddOn,
  BlindLevelDuration,
  Rebuy,
  StartingChip,
} from '../models/event';

// VALIDATION CONSTANTS
export const ADMIN_FEES_PERCENT_MIN = 0;
export const ADMIN_FEES_PERCENT_MAX = 100;
export const ATTENDEE_LIMIT = 250;
export const MAX_PLAYERS_MIN = 1;
export const BUY_IN_MIN = 0;
export const REBUY_CUTOFF_MIN = 0;
export const REBUY_PRICE_MIN = 0;
export const REBUY_CHIPS_MIN = 0;
export const ADD_ON_PRICE_MIN = 0;
export const ADD_ON_AMOUNT_MIN = 0;
export const BIG_BLIND_ROUND_START_MIN = 0;
export const LATE_ENTRY_CUTOFF_MIN = 0;
export const RE_ENTRY_PRICE_MIN = 0;
export const RE_ENTRY_CUTOFF_MIN = 0;
export const RE_ENTRIES_MIN = 0;
export const BOUNTY_PRICE_MIN = 0;
export const BOUNTY_AMOUNT_MIN = 0;

// EVENT DEFAULT VALUES
const REBUY_DEFAULT: Rebuy = {
  isRebuys: false,
};

const ADD_ON_DEFAULT: AddOn = {
  isAddOn: false,
};

export const EVENT_DEFAULT: Event = {
  name: '',
  desc: '',
  privacy: 'private',
  startDateTime: null,
  location: {
    address: {
      label: '',
      value: '',
    },
    lat: null as unknown as number,
    lng: null as unknown as number,
  },
  timezone: null,
  currency: 'CAD',
  adminFees: [],
  gameType: 'holdem',
  gameLimit: 'no-limit',
  maxPlayers: 10,
  buyIn: 0,
  startingChips: 10000,
  blindLevelDuration: 30,
  rebuys: { ...REBUY_DEFAULT },
  addOn: { ...ADD_ON_DEFAULT },
  bigBlindAnte: {
    isBigBlindAnte: false,
    bigBlindAnteRoundStart: 0,
  },
  lateEntry: {
    isLateEntry: false,
    lateEntryCutoff: 0,
  },
  reEntry: {
    isReEntry: false,
    reEntries: 0,
    reEntryCutoff: 0,
    reEntryPrice: 0,
  },
  bounty: {
    isBounty: false,
    bountyAmount: 0,
    bountyPrice: 0,
  },
};

// FORM OPTIONS
export const REBUYS_ALLOWED_OPTIONS: { key: any; value: any }[] = [
  { key: 1, value: 1 },
  { key: 2, value: 2 },
  { key: 3, value: 3 },
  { key: 4, value: 4 },
  { key: 5, value: 5 },
  { key: 6, value: 6 },
  { key: 7, value: 7 },
  { key: 8, value: 8 },
  { key: 9, value: 9 },
  { key: 10, value: 10 },
  { key: 'unlimited', value: 'Unlimited' },
];

export const STARTING_CHIPS_OPTIONS: StartingChip[] = [
  { key: 1000, value: '1,000' },
  { key: 2000, value: '2,000' },
  { key: 5000, value: '5,000' },
  { key: 10000, value: '10,000' },
];

export const BLIND_LEVEL_DURATION_OPTIONS: BlindLevelDuration[] = [
  { key: 5, value: '5 mins' },
  { key: 10, value: '10 mins' },
  { key: 15, value: '15 mins' },
  { key: 20, value: '20 mins' },
  { key: 30, value: '30 mins' },
  { key: 45, value: '45 mins' },
];

// DUMMY VALUES (delete when good...)
export const DUMMY_EVENT_DATA: Event = {
  name: 'Super Poker: The Sequel',
  desc: `This is my fantastic event I cannot wait for you to attend! There will be poker and more poker!
    It's so great that this event will take place at a new and trendy casino in the heart of your area!
    Seats are limited since this is such a fantastic place to be!`,
  imageFile: null,
  privacy: 'private',
  startDateTime: '2024-06-07T17:09',
  location: {
    address: {
      label: 'Burnaby, BC, Canada',
      value: 'Burnaby, BC, Canada',
    },
    lat: 49.2488091,
    lng: -122.9805104,
  },
  timezone: 'America/Vancouver',
  currency: 'CAD',
  adminFees: [
    {
      payee: 'The Boss',
      percent: 20,
    },
  ],
  gameType: 'dealerschoice',
  gameLimit: 'no-limit',
  maxPlayers: 10,
  buyIn: 50000,
  startingChips: 10000,
  blindLevelDuration: 30,
  rebuys: {
    isRebuys: true,
    rebuysAllowed: 2,
    rebuyCutoff: 5,
    rebuyPrice: 60,
    rebuyChips: 5000,
  },
  addOn: {
    isAddOn: true,
    addOnPrice: 80,
    addOnAmount: 5000,
  },
  bigBlindAnte: {
    isBigBlindAnte: true,
    bigBlindAnteRoundStart: 5,
  },
  lateEntry: {
    isLateEntry: true,
    lateEntryCutoff: 2,
  },
  reEntry: {
    isReEntry: true,
    reEntries: 2,
    reEntryCutoff: 7,
    reEntryPrice: 800,
  },
  bounty: {
    isBounty: true,
    bountyAmount: 600,
    bountyPrice: 900,
  },
};
